module.exports = __webpack_public_path__ + "images/f53578a719689972e59a343fae5b4bd1.svg";